export default __webpack_public_path__ + "static/media/logo.bab3e1ce.png";